import { cn } from '../../@/lib/utils'
import { SimpleProject } from '../../common/hooks/useOrgProjects'
import { getAvatarColorsForString } from '../../common/styles/colors'

type ProjectAvatarProps = {
  project?: SimpleProject
  small?: boolean
}
export function ProjectAvatar({ project, small }: ProjectAvatarProps) {
  const avatarClassnames = getAvatarColorsForString(project?.name || '')
  if (!small) {
    return (
      <div
        className={cn(
          'flex items-center justify-center h-6 w-6 min-w-6 min-h-6 rounded font-normal',
          avatarClassnames,
        )}
      >
        {project?.name.at(0) || '?'}
      </div>
    )
  }

  return (
    <div
      className={cn(
        'flex items-center justify-center h-5 w-5 min-w-5 min-h-5 rounded text-2xs font-normal',
        avatarClassnames,
      )}
    >
      {project?.name.at(0) || '?'}
    </div>
  )
}
